function Title() {
  return (
    <div className="header-title">
      <h4 className="header-title__text	">Note App</h4>
    </div>
  );
}

export default Title;
